export const TEAM_MEMBER_FILTER_TYPE = 1;
export const STATUS_FILTER_TYPE = 2;
export const PROVIDER_FILTER_TYPE = 3;
export const FACILITY_CONTACT_FILTER_TYPE = 4;
export const FACILITY_FILTER_TYPE = 5;

export const READ_MESSAGE_STATUS_FILTER_ID = 1;
export const UNREAD_MESSAGE_STATUS_FILTER_ID = 2;
export const CLOSED_STATUS_FILTER_ID = 3;
export const AT_LEAST_ONE_RESPONSE_STATUS_FILTER_ID = 4;
export const ALL_MESSAGES_STATUS_FILTER_ID = 5;

export const statuses = [
  {
    id: READ_MESSAGE_STATUS_FILTER_ID,
    name: 'Read Messages',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: UNREAD_MESSAGE_STATUS_FILTER_ID,
    name: 'Unread Messages',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: CLOSED_STATUS_FILTER_ID,
    name: 'Closed Messages',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: AT_LEAST_ONE_RESPONSE_STATUS_FILTER_ID,
    name: 'At Least 1 Response',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: ALL_MESSAGES_STATUS_FILTER_ID,
    name: 'All Messages',
    filterTypeId: STATUS_FILTER_TYPE
  },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/communicationsFilterEnums.ts